import { defineMessages } from 'react-intl';

const messages = defineMessages({
  std_notif_txt: {
    id: 'ICEUWD',
    defaultMessage: 'Go to Standard',
  },
  pa_sub_headline: {
    id: 'CDUNDH',
    defaultMessage:
      'Start exploring IBMs pricing for your unique requirements.',
  },
  more_info_text: {
    id: 'y6FZ6y',
    defaultMessage: 'More Information',
  },
  prem_ram_info2: {
    id: 'AvPXRQ',
    defaultMessage: '- can upgrade by 16GB multiples',
  },
  prem_ram_info1: {
    id: 'wQmhHS',
    defaultMessage: 'Includes 64GB of RAM',
  },
  slider1_text: {
    id: 'EwRIOm',
    defaultMessage: 'User',
  },
  est_feat_pt1: {
    id: 'QN+AjZ',
    defaultMessage: 'Connected Planning',
  },
  std_feat_pt3: {
    id: 'Mup9SP',
    defaultMessage: 'High Availability',
  },
  std_feat_pt4: {
    id: 'ZX26XH',
    defaultMessage: 'Auditing and Logging',
  },
  tooltip_ram_text: {
    id: 'y1BCJF',
    defaultMessage: 'Adequate RAM is required based on expected usage.',
  },
  std_feat_pt1: {
    id: 'Me1b0H',
    defaultMessage: 'Both Excel and Web Interfaces',
  },
  est_feat_pt3: {
    id: '/6PbZi',
    defaultMessage: 'Core model building',
  },
  disclaimer_text: {
    id: 'gGOcgE',
    defaultMessage:
      'Calculated prices are estimates provided for planning purposes only taking into account potential IBM discounts, and are not a formal offer from IBM or an IBM Business Partner. The estimation may reflect the total discounted price. Certain factors such as configuration, add-ons, additional requirements or related services will affect final price. IBM Business Partners set and provide their own IBM Planning Analytics pricing, and neither IBM nor IBM Business Partners are bound by the provided estimate.',
  },
  est_feat_pt2: {
    id: 'vOMNUR',
    defaultMessage: 'Either Excel or Web interface',
  },
  std_feat_pt2: {
    id: 'VesjHO',
    defaultMessage: 'AI-based forecasting',
  },
  std_ram_info2: {
    id: '/3UCfW',
    defaultMessage: '- can upgrade up to 128GB in 16GB multiples',
  },
  est_feat_pt4: {
    id: 'mR3RDy',
    defaultMessage: 'Self-Service Data Import',
  },
  user_text: {
    id: 'EwRIOm',
    defaultMessage: 'User',
  },
  std_ram_info1: {
    id: 'gzgqC2',
    defaultMessage: 'Includes 32GB of RAM',
  },
  estimated_text: {
    id: 'RW/aNT',
    defaultMessage: 'Discounted monthly cost',
  },
  est_ram_info2: {
    id: 'ES/KsW',
    defaultMessage: '- can upgrade up to 32GB',
  },
  est_ram_info1: {
    id: 'MaqhtW',
    defaultMessage: 'Includes 16GB of RAM',
  },
  std_invalid_ram_text: {
    id: 'rCbetC',
    defaultMessage: 'Please use - + to add RAM multiple of 16GB',
  },
  std_feat_label: {
    id: 'bMhVwm',
    defaultMessage: 'All the features of Essentials, plus',
  },
  prem_pkg_desc: {
    id: 'Y9Sfi7',
    defaultMessage: 'Perfect for large enterprises.',
  },
  std_label: {
    id: 'cb2kY6',
    defaultMessage: 'Standard',
  },
  prem_label: {
    id: 'C5xzTC',
    defaultMessage: 'Premium',
  },
  env_text: {
    id: 'K7kuIZ',
    defaultMessage: 'Environment',
  },
  std_pkg_desc: {
    id: 'HJD3PF',
    defaultMessage: 'Built for growing companies.',
  },
  col1_text: {
    id: 'FCjGve',
    defaultMessage: 'Requirement',
  },
  thank_you: {
    id: 'aYIUar',
    defaultMessage: 'Thank you!',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  prem_user_info1: {
    id: 'CyD/1o',
    defaultMessage: 'Includes 20 users',
  },
  estimated_annual_text: {
    id: 'U36QvL',
    defaultMessage: 'Discounted annual cost',
  },
  prem_user_info2: {
    id: 'fzJK6z',
    defaultMessage: '- can add individual users',
  },
  prem_notif_label: {
    id: 'vt9nHB',
    defaultMessage: 'Information notification',
  },
  no: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  return_est_text: {
    id: '8fgwsI',
    defaultMessage: 'Return to price estimator',
  },
  est_invalid_ram_text: {
    id: 'Q2IUNJ',
    defaultMessage: 'Please provide a RAM range between 16-32',
  },
  recommend_text: {
    id: '9CHAKN',
    defaultMessage: 'Based on your input we recommend the next tier',
  },
  prem_feat_label: {
    id: '5ky40J',
    defaultMessage: 'All the features of Standard, plus',
  },
  prcie_text: {
    id: 'cVxiy4',
    defaultMessage: 'Prices shown do not include tax',
  },
  bp_desc: {
    id: '9k14Pe',
    defaultMessage:
      'I consent to IBM providing my business contact information: ',
  },
  contact_info: {
    id: 'R6Ef/+',
    defaultMessage: 'For a solution of this size please get in touch with us.',
  },
  est_label: {
    id: 'eXbuB9',
    defaultMessage: 'Essentials',
  },
  close_btn_text: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  std_invalid_usr_text: {
    id: 'rP9GtI',
    defaultMessage: 'Please provide a User above or equal to 10',
  },
  est_user_info1: {
    id: 'G0xaKN',
    defaultMessage: 'Includes 5 users',
  },
  est_user_info2: {
    id: '3297Dx',
    defaultMessage: '- can add up to 10 users',
  },
  pa_aws_headline: {
    id: 'd3GRRm',
    defaultMessage:
      'Get an instant price calculation for Planning Analytics as a Service',
  },
  est_pkg_desc: {
    id: 'NM7HIu',
    defaultMessage: 'Designed for small teams.',
  },
  gb_text: {
    id: 'LRu6Sn',
    defaultMessage: 'GB',
  },
  est_feat_label: {
    id: 'ZXp0z1',
    defaultMessage: 'Features',
  },
  more_info_desc1: {
    id: 'bBbB9F',
    defaultMessage:
      'Your IBM Planning Analytics SaaS price depends on the numbers of users and RAM utilized. The base package starts at 10 users and 32 GB RAM.',
  },
  more_info_desc2: {
    id: 'YuLQT+',
    defaultMessage:
      'Using this info, we can give you an estimate of what your monthly cost might look like based on what similar organizations are paying. For an accurate and customized quote, our specialists are always here to help.',
  },
  prem_feat_pt2: {
    id: '93lqAb',
    defaultMessage:
      'Source Control Management for teams spanning Finance, Sales, Marketing, Operations, HR, and IT',
  },
  prem_notif_txt: {
    id: '5M/GvW',
    defaultMessage: 'Go to Premium',
  },
  req_detail: {
    id: '0L49M8',
    defaultMessage: 'Request details:',
  },
  quote_text: {
    id: 'sIMSHR',
    defaultMessage: 'Request a Quote',
  },
  prem_feat_pt1: {
    id: 'EU2NYY',
    defaultMessage: 'Large-scale AI-based forecasting',
  },
  package_label: {
    id: 'RcNFA2',
    defaultMessage: 'Package',
  },
  std_feat_pt5: {
    id: 'L+XSjD',
    defaultMessage: 'Development and Production environments',
  },
  yes: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  std_feat_pt6: {
    id: '7Dftxw',
    defaultMessage: 'Self-Service custom Data Backup',
  },
  col2_text: {
    id: 'qVGRIE',
    defaultMessage: 'Quantity',
  },
  std_user_info2: {
    id: 'fzJK6z',
    defaultMessage: '- can add individual users',
  },
  received_text: {
    id: 'PwjLGb',
    defaultMessage: 'We have received your request',
  },
  std_user_info1: {
    id: 'PP80Py',
    defaultMessage: 'Includes 10 users',
  },
  book_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  more_info_heading: {
    id: 'vCcCFd',
    defaultMessage: 'Planning Analytics as a Service',
  },
  slider2_text: {
    id: '/0Mq/O',
    defaultMessage: 'RAM Memory',
  },
  est_invalid_usr_text: {
    id: 'rIT3iV',
    defaultMessage: 'Please provide a User range between 5-10',
  },
  tooltip_users_text: {
    id: 'zGrAyC',
    defaultMessage:
      'This is the standard user license for Planning Analytics as a Service. Permission configurations per user can be implemented within the product.',
  },
  martketplace_button: {
    id: 'bMRd9l',
    defaultMessage: 'Buy now on IBM Marketplace',
  },
  toggle_title: {
    id: 'YIzVny',
    defaultMessage:
      'Add Planning Analytics Assistant, powered by watsonx, to increase participation in the planning process.',
  },
  toggle_on: {
    id: 'a5msuh',
    defaultMessage: 'Yes',
  },
  toggle_off: {
    id: 'oUWADl',
    defaultMessage: 'No',
  },
  toggle_result: {
    id: 'a8HNFF',
    defaultMessage: 'Assistant add-on',
  },
});

export default messages;
